import { render, staticRenderFns } from "./fkjz_wqy.vue?vue&type=template&id=7041db4c&scoped=true&"
import script from "./fkjz_wqy.vue?vue&type=script&lang=js&"
export * from "./fkjz_wqy.vue?vue&type=script&lang=js&"
import style0 from "./fkjz_wqy.vue?vue&type=style&index=0&id=7041db4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7041db4c",
  null
  
)

export default component.exports